import React from 'react';

import { twMerge } from 'tailwind-merge';

import Typography from 'components/typography/typography';

import Banner from 'components/banner/banner';

import { createLocale } from 'locales';
import Tooltip from 'components/tooltip/tooltip';

const localize = createLocale('freelancerAvailableJobsLocales');

interface cardHeaderPropTypes {
  title?: string;
  isJobPersonal?: boolean;
  isJobaChoice?: boolean;
  isDerivedJob?: boolean;
  isAvailable?: boolean;
}

const CardHeader: React.FC<cardHeaderPropTypes> = (props) => {
  const { title, isJobPersonal, isJobaChoice, isDerivedJob, isAvailable } =
    props;
  let badge = '';
  let badgeColor = '';

  if (isJobPersonal === true) {
    badge = localize('personal');
    badgeColor = 'bg-mediumGreen';
  } else if (isJobaChoice) {
    badge = localize('interest');
    badgeColor = 'bg-veryLightBlue';
  } else {
    badge = localize('speed');
    badgeColor = 'bg-gold';
  }

  const badgeClassNames = twMerge(
    'flex items-center justify-center  w-fit h-6 px-2 rounded-lg text-white',
    badgeColor,
  );
  const derivedBadgeClassName = twMerge(
    'flex items-center justify-center  w-fit h-6 px-2 rounded-lg text-white mb-2 md:mb-auto md:mr-3',
    'bg-yellow',
  );

  const headerClassNames = twMerge(
    'w-full flex justify-between items-center h-fit my-3 bg-transparent mx-0 pl-1 md:px-4 rounded-md',
    isAvailable && 'hover:bg-gray75',
    isAvailable === false && 'shadow-none hover:bg-gray300',
  );
  const typoClassName = twMerge(
    'text-gray900',
    isAvailable === false && 'line-through',
  );

  return (
    <div className={headerClassNames}>
      <Typography as="h2" variant="body-large-bold" className={typoClassName}>
        {title || ''}
      </Typography>
      <div className="w-fit flex flex-col md:flex-row  justify-center items-end md:items-center">
        {!!isDerivedJob && (
          <Tooltip
            content={localize('derivedJobMessage')}
            position="top"
            tooltipClasssName="w-40 z-50"
          >
            <Banner
              title={localize('longerAssignment')}
              variants="neutral"
              typographyClassName="my-2 md:my-auto"
              className={derivedBadgeClassName}
            />
          </Tooltip>
        )}
        <Banner title={badge} variants="neutral" className={badgeClassNames} />
      </div>
    </div>
  );
};

export default CardHeader;
